import Naluri from '~/common/api/naluri';
import {
  CHAT_GET_STARRED_MESSAGES_BEGIN,
  CHAT_GET_STARRED_MESSAGES_SUCCESS,
  CHAT_GET_STARRED_MESSAGES_FAILURE,
  CHAT_GET_STARRED_MESSAGES_DISMISS_ERROR,
  CHAT_VIEW_STARRED_MESSAGES,
  CHAT_DELETE_ALL_BOOKMARKS,
  UPDATE_STARRED_PAGINATION,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getStarredMessages(channelId) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: CHAT_GET_STARRED_MESSAGES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { chat } = getState();

      let page = 1;

      if (chat.starredMessagesPagination) {
        page =
          chat.starredMessagesPagination.total > 30
            ? chat.starredMessagesPagination.page + 1
            : chat.starredMessagesPagination.page;
      }

      const doRequest = channelId
        ? Naluri.get(`/api/bookmarks?page=${page}&channel_id=${channelId}`)
        : Naluri.get(`/api/bookmarks?page=${page}`);
      doRequest.then(
        res => {
          dispatch({
            type: CHAT_GET_STARRED_MESSAGES_SUCCESS,
            starredMessages: res,
          });

          if (res.pagination) {
            const { page, pages } = res.pagination;
            if (page <= pages) {
              dispatch(updateStarredPagination(res.pagination));
            }
          }
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: CHAT_GET_STARRED_MESSAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export const updateStarredPagination = pagination => ({
  type: UPDATE_STARRED_PAGINATION,
  payload: pagination,
});

export const viewChatMessages = currentView => ({
  type: CHAT_VIEW_STARRED_MESSAGES,
  payload: currentView,
});

export const deleteAllStarred = current => ({
  type: CHAT_DELETE_ALL_BOOKMARKS,
  payload: current,
});

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetStarredMessagesError() {
  return {
    type: CHAT_GET_STARRED_MESSAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CHAT_GET_STARRED_MESSAGES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getStarredMessagesPending: true,
        getStarredMessagesError: null,
      };

    case CHAT_GET_STARRED_MESSAGES_SUCCESS:
      // The request is success
      let newState = state.starredMessages;

      action.starredMessages.data.forEach(message => {
        newState = newState.set(message.id, message);
      });

      return {
        ...state,
        starredMessages: newState,
        getStarredMessagesPending: false,
        getStarredMessagesError: null,
      };

    case CHAT_VIEW_STARRED_MESSAGES:
      return {
        ...state,
        viewStarredMessages: action.payload,
        getStarredMessagesPending: false,
        getStarredMessagesError: null,
      };

    case CHAT_DELETE_ALL_BOOKMARKS:
      return {
        ...state,
        deleteAllStarredMessages: action.payload,
        getStarredMessagesPending: false,
        getStarredMessagesError: null,
      };

    case UPDATE_STARRED_PAGINATION:
      return {
        ...state,
        starredMessagesPagination: action.payload,
      };

    case CHAT_GET_STARRED_MESSAGES_FAILURE:
      // The request is failed
      return {
        ...state,
        getStarredMessagesPending: false,
        getStarredMessagesError: action.data.error,
      };

    case CHAT_GET_STARRED_MESSAGES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getStarredMessagesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/chat/redux/getStarredMessages.js